import { useState } from "react";
import { useSelector } from "react-redux";
import useNovaAiResponseApi from "./useNovaAiResponseApi";
import useApplicationTracker from "customHooks/useApplicationTracker";
const useNovaAiMessageBubble = ({
  conversationId,
  aiResponse,
  aiMessageId,
}) => {
  const { captureUserEvent } = useApplicationTracker();
  const { accountId } = useSelector((state) => state.user);
  const { propsForGoalsNovaAi } = useNovaAiResponseApi();
  const { sendNovaChatFeedback } = propsForGoalsNovaAi;

  // UI State
  const [hovered, setHovered] = useState(false);
  const [copyTooltipVisible, setCopyTooltipVisible] = useState(false);
  const [likeTooltipVisible, setLikeTooltipVisible] = useState(false);
  const [dislikeTooltipVisible, setDislikeTooltipVisible] = useState(false);
  const [dislikeModalOpen, setDislikeModalOpen] = useState(false);
  const [reaction, setReaction] = useState(null);
  const [lockedReaction, setLockedReaction] = useState(false);

  // Copy functionality
  const handleCopy = () => {
    if (aiResponse?.text) {
      navigator.clipboard.writeText(aiResponse.text);
      setCopyTooltipVisible(true);
      captureUserEvent("nova_copy_response_button_clicked", {
        accountId: accountId,
      });
      setTimeout(() => {
        setCopyTooltipVisible(false);
      }, 3000);
    }
  };

  // Like functionality
  const handleLike = () => {
    if (lockedReaction) return;
    setReaction("like");
    setLockedReaction(true);
    setLikeTooltipVisible(true);
    setDislikeModalOpen(false);
    handleSendFeedback(conversationId, aiMessageId, "", 1);
  };

  // Dislike functionality
  const handleDislike = () => {
    if (lockedReaction) return;
    setReaction("dislike");
    setLockedReaction(true);
    setDislikeTooltipVisible(true);
    setDislikeModalOpen(true);
  };

  // Feedback submission
  const handleSubmitFeedback = (comments) => {
    handleSendFeedback(conversationId, aiMessageId, comments, 0);
    setDislikeModalOpen(false);
  };

  const handleCancelFeedback = () => {
    handleSendFeedback(conversationId, aiMessageId, "", 0);
    setDislikeModalOpen(false);
  };

  const handleSendFeedback = (
    conversationId,
    aiMessageId,
    comments,
    npsScore
  ) => {
    sendNovaChatFeedback({
      conversationId,
      messageId: aiMessageId,
      feedback: {
        key: "nova_ai_feedback_question",
        comments,
        nps_score: npsScore,
      },
    });
  };

  // Mouse event handlers
  const handleMouseEnter = () => setHovered(true);
  const handleMouseLeave = () => setHovered(false);

  return {
    // State
    hovered,
    copyTooltipVisible,
    likeTooltipVisible,
    dislikeTooltipVisible,
    dislikeModalOpen,
    reaction,
    lockedReaction,

    // Handlers
    handleCopy,
    handleLike,
    handleDislike,
    handleSubmitFeedback,
    handleCancelFeedback,
    handleMouseEnter,
    handleMouseLeave,

    // Modal control
    setDislikeModalOpen,
  };
};

export default useNovaAiMessageBubble;
